var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPodcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Podcast") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-81.000000, -75.000000)",
    fill: "#C41D73",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(75.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,13 C3.67157288,13 3,12.3284272 3,11.5 C3,10.6715728 3.67157288,10 4.5,10 C5.32842712,10 6,10.6715728 6,11.5 C6,12.3284272 5.32842712,13 4.5,13 Z M4.1362009,6.01296913 C7.13748628,6.49212068 9.50278501,8.85927239 9.9887074,11.862909 C10.0816043,12.4636363 9.58853602,13 8.98113302,13 C8.47377287,13 8.06645557,12.6209697 7.98070456,12.1203636 C7.60911685,10.032121 5.9655558,8.38012084 3.87894786,8.01539354 C3.37873363,7.92957535 3,7.52193895 3,7.01418133 C3,6.4063025 3.53594382,5.91284791 4.1362009,6.01296913 Z M4.00732391,3.00524438 C8.75336923,3.47657329 12.5243767,7.25366117 12.9957526,11.9927766 C13.0474102,12.5286711 12.6212347,13 12.0788296,13 C11.6074536,13 11.2200214,12.6448892 11.1748209,12.1735603 C10.7873887,8.29316741 7.70084489,5.2069315 3.82006497,4.81953787 C3.35514625,4.77434195 3,4.38694832 3,3.9156194 C3,3.37972488 3.47137593,2.94713533 4.00732391,3.00524438 Z",
    id: "\\uD83D\\uDD39Icon-Color"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcast);
export default __webpack_public_path__ + "static/media/podcast.3856d4935aff8edd8e54730d441a2980.svg";
export { ForwardRef as ReactComponent };